import firebase from 'firebase/compat/app';

import { FirebaseConfig } from './appConfig';

const initFirebase = (firebaseConfig: FirebaseConfig) => {
  firebase.initializeApp(firebaseConfig);
};

export default initFirebase;
